import { Alert, message, PageHeader, Select, Spin, Upload, Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
  Form,
  FormItem,
  SelectItem,
  TableItem,
  ButtonItem,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'
import moment from 'moment'
import {
  NOMBRE_HOJA,
  COLUMNAS_NO_MAPEABLES,
  construirIndiceEncabezados,
  mapearFilaExterna,
  agruparAvisosCatalogo,
} from './mapeoExterno'
import { textoCodigosRepetidos } from '../ImportarEmpleados/plantillaEmpleados'

const { Option } = Select

class ImportarEmpleadosExterno extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    // Se guardan las filas crudas para poder recalcular sin volver a subir el
    // archivo cuando cambian los valores generales.
    filasCrudas: [],
    data: [],
    archivoError: null,
    archivoOmitidos: null,
    omitidosPorBaja: 0,
    avisosPerdidos: 0,
    avisosCatalogo: [],
    // Valores que el layout externo no trae y se aplican a todos los empleados
    regimenFiscalId: undefined,
    tipoJornadaId: undefined,
    // Catálogos para resolución de IDs
    tiposContrato: [],
    formasDePago: [],
    turnos: [],
    tiposPeriodo: [],
    tiposPrestacion: [],
    bancos: [],
    registrosPatronales: [],
    regimenFiscal: [],
    tiposRegimen: [],
    tiposJornada: [],
    estados: [],
  }

  componentDidMount() {
    this.setState({ loading: true })
    axios
      .post(
        "empleados/datosParaImportarEmpleados",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            tiposContrato:      res.data.tiposContrato      || [],
            formasDePago:       res.data.formasDePago       || [],
            turnos:             res.data.turnos             || [],
            tiposPeriodo:       res.data.tiposPeriodo       || [],
            tiposPrestacion:    res.data.tiposPrestacion    || [],
            bancos:             res.data.bancos             || [],
            registrosPatronales: res.data.registrosPatronales || [],
            regimenFiscal:      res.data.regimenFiscal      || [],
            tiposRegimen:       res.data.tiposRegimen       || [],
            tiposJornada:       res.data.tiposJornada       || [],
            estados:            res.data.estados            || [],
          });
        }
        this.setState({ loading: false });
      });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed() {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish() {
    if (!this.state.data.length) {
      message.error("No hay datos para importar");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "empleados/importarEmpleados",
        { empresaId: this.props.empresaId, data: this.state.data },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se importaron " + res.data.numero + " empleados");
          if (res.data.repetidos) {
            message.warning("No se importaron " + res.data.repetidos + " empleados ya que estaban repetidos");
          }
          if (res.data.fallidos) {
            message.warning("No se importaron " + res.data.fallidos + " empleados por datos inválidos");
          }
          const avisoCodigos = textoCodigosRepetidos(res.data.codigosRepetidos);
          if (avisoCodigos) message.warning(avisoCodigos, 10);
          if (res.data.lideresNoEncontrados) {
            message.warning("No se encontró el líder de " + res.data.lideresNoEncontrados + " empleado(s); asígnalo manualmente");
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error("No se pueden importar los empleados");
        } else {
          message.error("Hubo un error y los empleados no se importaron");
        }
      });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando' }] });
      this.cargarArchivoExcel(e.file)
    } else {
      message.error('El archivo debe ser un archivo de excel')
      this.setState({ loading: false })
    }
  }

  descargarArchivo(workbook, nombreArchivo) {
    let wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = nombreArchivo;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  descargarArchivoErrores() {
    this.descargarArchivo(this.state.archivoError, 'errores_empleados.xlsx');
  }

  descargarArchivoOmitidos() {
    this.descargarArchivo(this.state.archivoOmitidos, 'omitidos_por_baja_empleados.xlsx');
  }

  cargarArchivoExcel(file) {
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array', cellDates: true })
      const hoja = workbook.Sheets[NOMBRE_HOJA]
      if (!hoja) {
        message.error('No se encontró la hoja "' + NOMBRE_HOJA + '" en el archivo')
        this.setState({ loading: false, archivosExcel: [{ ...file, name: file.name, status: 'error' }] });
        return;
      }
      let filas = XLSX.utils.sheet_to_row_object_array(hoja, { raw: false, dateNF: 'YYYY-MM-DD' })
      const dataReturn = this.archivoVerificar(filas)
      this.setState({
        archivosExcel: [{ ...file, name: file.name, status: 'success' }],
        filasCrudas: filas,
        data: dataReturn.objeto,
        archivoError: dataReturn.errores ? dataReturn.archivoErrores : null,
        archivoOmitidos: dataReturn.omitidos ? dataReturn.archivoOmitidos : null,
        omitidosPorBaja: dataReturn.omitidos,
        avisosPerdidos: dataReturn.avisosPerdidos,
        avisosCatalogo: dataReturn.avisosCatalogo,
        loading: false,
      });
      if (dataReturn.errores) {
        message.error('Se han detectado ' + dataReturn.errores + ' errores')
      }
      if (dataReturn.omitidos) {
        message.warning(dataReturn.omitidos + ' empleado(s) se omitieron por estar de baja')
      }
      message.success('Se encontraron ' + dataReturn.objeto.length + ' empleados para importar')
    }
  }

  // Al cambiar un valor general se rehace el mapeo sobre las filas ya leídas,
  // para que lo que se envía lleve siempre el valor elegido sin volver a subir.
  cambiarValorGeneral(campo, valor) {
    this.setState({ [campo]: valor }, () => {
      if (!this.state.filasCrudas.length) return;
      const dataReturn = this.archivoVerificar(this.state.filasCrudas);
      this.setState({ data: dataReturn.objeto });
    });
  }

  archivoVerificar(filas) {
    const catalogos = {
      tiposContrato: this.state.tiposContrato,
      formasDePago: this.state.formasDePago,
      turnos: this.state.turnos,
      tiposPeriodo: this.state.tiposPeriodo,
      tiposPrestacion: this.state.tiposPrestacion,
      bancos: this.state.bancos,
      registrosPatronales: this.state.registrosPatronales,
      tiposRegimen: this.state.tiposRegimen,
      estados: this.state.estados,
    }
    const indice = construirIndiceEncabezados(filas)
    const generales = {
      regimenFiscalId: this.state.regimenFiscalId,
      tipoJornadaId: this.state.tipoJornadaId,
    }

    let errores = 0
    let omitidos = 0
    let avisosPerdidos = 0
    const arrayErrores = []
    const arrayOmitidos = []
    const todosLosAvisos = []
    const objeto = []

    for (const fila of filas) {
      const r = mapearFilaExterna(fila, indice, catalogos, generales)

      if (r.omitirPorBaja) {
        omitidos++
        arrayOmitidos.push(r.datosOmision)
        continue
      }
      if (r.erroresFila.length) {
        errores++
        arrayErrores.push({ Errores: r.erroresFila.join(', '), Fila: r.numFila, ...fila })
        continue
      }
      avisosPerdidos += r.avisosPerdidos
      todosLosAvisos.push(...r.avisosCatalogo)
      objeto.push(r.emp)
    }

    let archivoErrores = null
    if (arrayErrores.length) {
      archivoErrores = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(archivoErrores, XLSX.utils.json_to_sheet(arrayErrores), 'Hoja Errores')
    }
    let archivoOmitidos = null
    if (arrayOmitidos.length) {
      archivoOmitidos = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(archivoOmitidos, XLSX.utils.json_to_sheet(arrayOmitidos), 'Omitidos por Baja')
    }

    return {
      objeto,
      errores,
      omitidos,
      avisosPerdidos,
      avisosCatalogo: agruparAvisosCatalogo(todosLosAvisos),
      archivoErrores,
      archivoOmitidos,
    }
  }

  render() {
    const columns = [
      { title: 'Cód.', dataIndex: 'numeroClave', key: 'numeroClave', width: 60 },
      {
        title: 'Nombre Completo', key: 'nombreCompleto', width: 200, fixed: 'left',
        render: (_, r) => [r.nombre, r.apellidoPaterno, r.apellidoMaterno].filter(Boolean).join(' '),
      },
      { title: 'RFC',  dataIndex: 'rfc',  key: 'rfc',  width: 140 },
      { title: 'CURP', dataIndex: 'curp', key: 'curp', width: 190 },
      { title: 'Fecha Alta', dataIndex: 'fechaAlta', key: 'fechaAlta', width: 110,
        render: (v) => v ? moment(v).format('DD/MM/YYYY') : '-' },
      { title: 'Sexo', dataIndex: 'sexo', key: 'sexo', width: 75, render: (v) => v || '-' },
      { title: 'Sal. Diario', dataIndex: 'salarioDiario', key: 'salDiario', width: 100,
        render: (v) => v !== undefined ? `$${v}` : '-' },
      { title: 'SBC', dataIndex: 'sbcParteFija', key: 'sbc', width: 90,
        render: (v) => v !== undefined ? `$${v}` : '-' },
      { title: 'Saldo Ajuste Neto', dataIndex: 'saldoAjusteNeto', key: 'saldoAjusteNeto', width: 130,
        render: (v) => v !== undefined ? `$${v}` : '-' },
      { title: 'Tipo Periodo', dataIndex: 'tipoPeriodo', key: 'tipoPeriodo', width: 120, render: (v) => v || '-' },
      { title: 'Turno', dataIndex: 'turno', key: 'turno', width: 110, render: (v) => v || '-' },
      { title: 'Registro Patronal', dataIndex: 'registroPatronalIMSS', key: 'registroPatronal', width: 150, render: (v) => v || '-' },
      { title: 'Departamento', dataIndex: 'departamento', key: 'depto', width: 130, render: (v) => v || '-' },
      { title: 'Puesto', dataIndex: 'puesto', key: 'puesto', width: 130, render: (v) => v || '-' },
      { title: 'Tipo Contrato', dataIndex: 'tipoContrato', key: 'tipoContrato', width: 120, render: (v) => v || '-' },
      { title: 'Banco', dataIndex: 'banco', key: 'banco', width: 110, render: (v) => v || '-' },
      { title: 'Correo', dataIndex: 'correoElectronico', key: 'correo', width: 180, render: (v) => v || '-' },
    ]

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Empleados Desde Software Externo"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {this.state.archivoOmitidos &&
                <ButtonItem onClick={this.descargarArchivoOmitidos.bind(this)} style={{ marginRight: 8 }}>
                  Descargar Omitidos por Baja
                </ButtonItem>}
              {this.state.archivoError &&
                <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>Descargar Errores</ButtonItem>}
            </>
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor">
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 15 }}
              message="Columnas del archivo externo sin equivalente en el sistema"
              description={'Estas columnas no se importan porque el sistema no tiene un campo para guardarlas: ' + COLUMNAS_NO_MAPEABLES.join(', ') + '.'}
            />
            {this.state.avisosCatalogo.length > 0 &&
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 15 }}
                message="Valores que no existen en los catálogos de la empresa"
                description={
                  <>
                    <div style={{ marginBottom: 6 }}>
                      Los empleados se importan de todos modos, pero estos campos quedarán vacíos.
                      Da de alta estos valores en su catálogo y vuelve a importar para que se llenen.
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                      {this.state.avisosCatalogo.map((g) => (
                        <li key={g.catalogo}>
                          <b>{g.catalogo}:</b>{' '}
                          {g.valores.map((v) => `${v.valor} (${v.filas} empleado${v.filas !== 1 ? 's' : ''})`).join(', ')}
                        </li>
                      ))}
                    </ul>
                  </>
                }
              />}
            {this.state.avisosPerdidos > 0 &&
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 15 }}
                message={`${this.state.avisosPerdidos} empleado(s) tenían más de un aviso pendiente ante el IMSS marcado; solo se guardó el más relevante`}
              />}
            <Form
              ref={this.formRef}
              name="importarEmpleadosExterno"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row style={{ marginTop: 20 }}>
                <Col span={24}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept='.xlsx'
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Régimen Fiscal">
                    <SelectItem
                      placeholder="Igual para todos los empleados"
                      allowClear
                      value={this.state.regimenFiscalId}
                      onChange={(v) => this.cambiarValorGeneral('regimenFiscalId', v)}
                    >
                      {this.state.regimenFiscal.map((r) => (
                        <Option key={r._id} value={r._id}>
                          {`${r.c_RegimenFiscal} - ${r.descripcion}`}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} md={12}>
                  <FormItem label="Tipo de Jornada">
                    <SelectItem
                      placeholder="Igual para todos los empleados"
                      allowClear
                      value={this.state.tipoJornadaId}
                      onChange={(v) => this.cambiarValorGeneral('tipoJornadaId', v)}
                    >
                      {this.state.tiposJornada.map((j) => (
                        <Option key={j._id} value={j._id}>
                          {`${j.c_TipoJornada} - ${j.Descripcion}`}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </Col>
              </Row>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 15 }}
                message="El archivo externo no trae Régimen Fiscal ni Tipo de Jornada. Elígelos aquí y se aplican a todos los empleados del archivo; si los dejas vacíos, esos campos quedan sin llenar."
              />
            </Form>
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ImportarEmpleadosExterno);
